// src/game/menuLayout.ts — Menünün pad/klavye gezinti ızgarasının KOORDİNATLARI.
//
// NEDEN AYRI DOSYA: menu.ts çalışma zamanında three.js ve view/* çekiyor; testler onu düz Node'da import
// edemez (roster.ts'in yazılı kuralı). Koordinatlar burada durunca hem menü hem test AYNI kaynaktan okur —
// test/uiNav.test.ts eskiden elle kopyalanmış bir aynaydı ve menüden sessizce ayrışmıştı (EĞİTİM satırını
// hiç bilmiyordu, yani yeşil yanan bir test artık var olmayan bir menüyü doğruluyordu).
//
// Izgara: karakter düğmeleri solda üç sütun (0–2), sağ panelin tüm öğeleri tek sütunda alt alta.

/** Karakter ızgarası sütun sayısı — index.html `.m-chars` (repeat(3, 1fr)) ile aynı olmalı. */
export const GRID_COLS = 3;

/** Sağ panelin sütunu. Karakter ızgarasının en sağı 2; 4 seçilmesi araya boşluk bırakır ve
 *  `navNext`in yanal puanlamasında sağ panelin tek blok gibi davranmasını sağlar. */
export const MENU_COL = 4;

/** Sağ panel öğelerinin SATIRLARI, yukarıdan aşağıya. Sıra ekrandaki sırayla aynı olmak zorunda:
 *  yön tuşları koordinat üzerinden en yakın komşuyu seçiyor, ekran sırasıyla ayrışırsa gezinti "atlar". */
export const MENU_ROWS = { fight: 0, online: 1, train: 2, bots: 3, diff: 4, quality: 5 } as const;

export type MenuRowName = keyof typeof MENU_ROWS;
